import type { IUserRepository } from '../repositories/IUserRepository.js';
import type { OrgSummaryEntity } from '../entities/UserEntity.js';

interface Dependencies {
  userRepository: IUserRepository;
}

export function createGetMyOrgsUseCase({ userRepository }: Dependencies) {
  return async function getMyOrgs(input: { profileId: string }): Promise<OrgSummaryEntity[]> {
    return userRepository.getMyOrgs(input.profileId);
  };
}
